import { h } from 'preact';
import { Link } from 'preact-router/match';
import style from './style';

const Header = () => (
	<div class={style.header}>
	<nav>
	<Link href="/">
	<div class="logo">
	<svg width="879" height="565" viewBox="0 0 879 565" fill="none" xmlns="http://www.w3.org/2000/svg">

<circle cx="282.001" cy="282.001" r="282.001" fill="#EE337A"/>		
</svg>

</div>
</Link>
	
		</nav>
	</div>
);

export default Header;



// WEBPACK FOOTER //
// ./components/header/index.js